<template>
    <AuthenticatedLayout
        :title="__(page.title)"
        :footerContainer="false"
    >
    <div class="max-w-screen-xl w-full mx-auto">

        <div class="bg-white text-gray-900 rounded-md shadow-md flex flex-col">
            <div class="p-8">
                <Heading
                    :label="__(page.title)"
                    class="justify-center"
                />
                <div class="ql-snow">
                    <div v-html="page.content" class="ql-editor content"></div>
                </div>
            </div>
        </div>
    </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated';
import SvgIcon from 'UI/SvgIcon';
import Heading from 'COMP/Heading';

export default {
    components: {
        AuthenticatedLayout,
        SvgIcon,
        Heading,
    },
    props: {
        page: Object,
    },
    setup(props) {

    },
}
</script>
